import { render, staticRenderFns } from "./ApplicantUpdate.vue?vue&type=template&id=4d935648&"
import script from "../../../services/admin/applicant/applicant-update.js?vue&type=script&lang=js&"
export * from "../../../services/admin/applicant/applicant-update.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports